import { tienePermiso, CODIGOS_PERMISOS, getNivelRol } from './permisosHelper';

// PERMISOS LEGACY - Mantener por compatibilidad con código existente
export const PERMISOS = {
  SIN_ACCESO: 0,
  MIEMBRO: 1,
  DIGITADOR: 2,
  JEFE_GRUPO: 3,
  ADMINISTRADOR: 4,
  PASTOR: 5,
  TESORERO: 6,
  ZONA: 7,
  DISTRITO: 8,
  PROGRAMADOR: 9
};

// NUEVO SISTEMA - Funciones basadas en códigos de permisos
export const PERMISOS_MODULOS = {
  // Acceso al sistema
  PUEDE_ACCEDER: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.ACCEDER_SISTEMA);
  },

  // Consulta de documentos
  PUEDE_CONSULTAR_DOCUMENTOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS) ||
           tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_PROPIOS) ||
           tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_GRUPO) ||
           tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_LOCAL) ||
           tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_TODOS_DOCUMENTOS);
  },

  PUEDE_CONSULTAR_SOLO_PROPIOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_PROPIOS) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_GRUPO) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_LOCAL) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_TODOS_DOCUMENTOS);
  },

  PUEDE_CONSULTAR_GRUPO: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_GRUPO) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_LOCAL) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_TODOS_DOCUMENTOS);
  },

  PUEDE_CONSULTAR_LOCAL: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_DOCUMENTOS_LOCAL) &&
           !tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_TODOS_DOCUMENTOS);
  },

  PUEDE_CONSULTAR_TODOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CONSULTAR_TODOS_DOCUMENTOS);
  },

  PUEDE_EXPORTAR: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.EXPORTAR_DOCUMENTOS);
  },

  // Registro de documentos
  PUEDE_REGISTRAR_INGRESOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.REGISTRAR_INGRESOS);
  },

  PUEDE_REGISTRAR_GASTOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.REGISTRAR_GASTOS);
  },

  PUEDE_REGISTRAR_DOCUMENTOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.REGISTRAR_INGRESOS) ||
           tienePermiso(usuario, CODIGOS_PERMISOS.REGISTRAR_GASTOS);
  },

  PUEDE_EDITAR_DOCUMENTOS: (usuario) => {
    return usuario && usuario.Permiso >= PERMISOS.TESORERO;
  },

  PUEDE_ELIMINAR_IMAGENES: (usuario) => {
    return usuario && usuario.Permiso >= PERMISOS.TESORERO;
  },

  // Anulación
  PUEDE_ANULAR: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.ANULAR_DOCUMENTOS);
  },

  // Gestión de usuarios
  PUEDE_VER_USUARIOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.VER_USUARIOS);
  },

  PUEDE_CREAR_USUARIOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.CREAR_USUARIOS);
  },

  PUEDE_EDITAR_USUARIOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.EDITAR_USUARIOS);
  },

  PUEDE_ELIMINAR_USUARIOS: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.ELIMINAR_USUARIOS);
  },

  PUEDE_ASIGNAR_ROLES: (usuario) => {
    return tienePermiso(usuario, CODIGOS_PERMISOS.ASIGNAR_ROLES);
  },

  // Funciones auxiliares
  PUEDE_VER_TODOS_USUARIOS: (usuario) => {
    // Zona o superior puede ver todos los usuarios
    return getNivelRol(usuario) >= 7;
  },

  PUEDE_SELECCIONAR_LOCAL: (usuario) => {
    // Solo Zona o superior puede seleccionar cualquier local
    return getNivelRol(usuario) >= 7;
  },

  PUEDE_SELECCIONAR_GRUPO: (usuario) => {
    // Administrador o superior puede seleccionar grupo
    return getNivelRol(usuario) >= 4;
  }
};

// Exportar también las funciones del nuevo sistema
export { tienePermiso, CODIGOS_PERMISOS, getNivelRol, getPermisosUsuario } from './permisosHelper';